(function ($) {
  var allMarkers

  function initMarkers (city, country) {
    window.gmap.removeMarkers()

    var data = {
      'action': 'get_markers',
      'city': city,
      'country': country
    }

    $.post(ajax.url, data, function (response) {
      allMarkers = JSON.parse(response)

      if (response === null) {
        return
      }

      populate(allMarkers)
      window.gmap.mapCanvas.setZoom(2)

      // Use our new bounds method if only 1 element
      if (Object.keys(allMarkers).length === 1) {
        setNewBounds()
      }
    })
  }

  /**
   * Center our map on a marker; provided centering method sucks
   */
  function setNewBounds () {
    if (window.gmap.addedMarkers === undefined) {
      return
    }

    var marker = window.gmap.addedMarkers[0]
    var location = marker['location']

    var latLng = new google.maps.LatLng(location[0], location[1])
    window.gmap.mapCanvas.setCenter(latLng)
  }

  function getPopupHtml (name, data) {
    var html = '<div class="pin-holder">'
    html += '<div class="pin-description">'
    html += '<div class="image-holder">'
    html += '<img src="' + ajax.theme_url + '/assets/images/location-01.jpg" alt="location">'
    html += '</div>' // .image-holder
    html += '<span>' + name + '</span>'
    html += '<a href="' + ajax.permalink + '/city-profiles/' + name + '">VIEW PROFILE <i class="icon-transfer-n"></i></a>'
    html += '</div>'
    html += '<a href="#" class="pin"><i class="icon-location"></i></a>'
    html += '</div>'

    return html
  }

  function populate (markerData) {
    var markers = []
    $.each(markerData, function (name, data) {
      if (data.geopol.latitude === undefined) {
        console.log("No coordinates for " + name)
        return true // continue
      }

      var marker = {}
      marker.location = [
        data.geopol.latitude,
        data.geopol.longitude
      ]
      marker.popupHTML = getPopupHtml(name, data)
      markers.push(marker)
    })

    window.gmap.addMarkers(markers)
  }

  $(document).ready(function () {
    // If there is no map, return early
    if ($('.map-holder').length === 0) {
      return
    }

    var country = $('.js-search-country').val()
    var city = $('.js-search-city').val()

    initMarkers(city, country)

    $('.js-search-submit').click(function (e) {
      e.preventDefault()

      country = $('.js-search-country').val()
      city = $('.js-search-city').val()
      initMarkers(city, country)
    })
  })
})(jQuery);
